
import { defineComponent, PropType } from 'vue'
import { CtSupplier } from '@/models/interfaces/content-type'
import TrashIcon from '@/components/Icons/TrashIcon.vue'
import SupplierApiSettings from '@/pages/WIP/components/SupplierApiSettings.vue'
import SupplierSettings from '@/pages/WIP/components/SupplierSettings.vue'
import SupplierAddress from '@/pages/WIP/components/SupplierAddress.vue'
import SupplierBillingAddress from '@/pages/WIP/components/SupplierBillingAddress.vue'
import SupplierPaymentDetails from '@/pages/WIP/components/SupplierPaymentDetails.vue'
import SupplierAccountingDetails from '@/pages/WIP/components/SupplierAccountingDetails.vue'
import SupplierRegistrationDetails from '@/pages/WIP/components/SupplierRegistrationDetails.vue'
import SupplierInvoiceCustomization from '@/pages/WIP/components/SupplierInvoiceCustomization.vue'

interface CombinedProducts {
  supplierCatalogue_id: string,
  active: boolean,
}

interface ProductState {
  curr: CombinedProducts[],
  prev: CombinedProducts[],
}

export default defineComponent({
  name: 'SupplierDetails',
  props: {
    supplier: {
      type: Object as PropType<CtSupplier>,
      required: true,
    },
    activeToggle: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    TrashIcon,
    SupplierSettings,
    SupplierApiSettings,
    SupplierAddress,
    SupplierBillingAddress,
    SupplierPaymentDetails,
    SupplierAccountingDetails,
    SupplierRegistrationDetails,
    SupplierInvoiceCustomization,
  },
  emits: ['update:supplier'],
  setup () {
    return {}
  }
})
